import React from 'react';
import { Button, Space } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

interface Props {
  daysLeft?: number;
  handleClick: () => void;
  isAccountActive?: boolean;
  isContractAccepted?: boolean;
}

const TrialBanner: React.FC<Props> = ({
  daysLeft,
  handleClick,
  isAccountActive,
  isContractAccepted,
}) => (
  <Space size="middle" css="padding-right: 16px !important;margin-top: 5px">
    {isAccountActive === false && (
      <Button type="default" danger icon={<ExclamationCircleOutlined />}>
        <FormattedMessage defaultMessage="Account Expired" />
      </Button>
    )}

    {daysLeft === 0 && (
      <span css="white-space: nowrap">
        <FormattedMessage defaultMessage="Your trial ends today" />
      </span>
    )}
    {daysLeft !== undefined && daysLeft > 0 && (
      <span css="white-space: nowrap">
        <FormattedMessage
          defaultMessage="Your trial ends in {days, plural, one {# day} other{# days}}"
          values={{ days: daysLeft }}
        />
      </span>
    )}

    {!isContractAccepted && (
      <Button type="default" onClick={handleClick}>
        <FormattedMessage defaultMessage="Activate Now!" />
      </Button>
    )}
  </Space>
);

export default TrialBanner;
